import * as React from 'react'
import { Navigation, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { pipe, RA } from '@packages/prelude'
import { styled } from 'styled-components'
import { react } from '~/commons'

interface Props {
  proposals: ReadonlyArray<string>
}

const Container = styled.div.attrs({
  className: 'd-flex flex-column align-items-center px-0 px-lg-5 py-3'
})``

const Text = styled.div.attrs({
  className: 'mx-lg-5 my-lg-3'
})``

const View: React.FC<Props> = ({ proposals }) => {
  return (
    <Swiper
      direction="horizontal"
      modules={[Navigation, Pagination]}
      slidesPerView={1}
      slidesPerGroup={1}
      loop={false}
      speed={1000}
      navigation={true}
      pagination={{ clickable: true }}>
      {pipe(
        proposals,
        RA.foldMapWithIndex(react.monoid)((key, proposal) => (
          <SwiperSlide key={key}>
            <Container>
              <Text dangerouslySetInnerHTML={{ __html: proposal }} />
            </Container>
          </SwiperSlide>
        ))
      )}
    </Swiper>
  )
}

export default Object.assign(View, {})
